import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
import { SectionCTA } from '../SectionCTA';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-329" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto max-w-5xl" data-id="element-330" data-mp="3mepnd1ioybv5">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-331" data-mp="3r7sfr6bqff9r">
          ⭐ Verified feedback
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-332" data-mp="y4kfnbcuey">
          What dentists are saying
        </h2>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-333" data-mp="91mi798sosrb">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-navy-100 bg-white p-5 shadow-soft" data-id="element-334" data-mp="dzxnr7s24h3q">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-335" data-mp="2fs3s0cqnmc7w">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-336" data-mp="1slazpmzbixb8" data-mpi={i} />)}
              </div>

              <blockquote className="mt-3 flex-1 font-display text-[16.5px] italic leading-snug text-ink" data-id="element-337" data-mp="1iuzhqwisunlc">
                “{t.quote}”
              </blockquote>

              <figcaption className="mt-5 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-338" data-mp="2bjn6x36o5x46">
                <img src={t.photo} alt={`${t.name}, ${t.role}`} className="h-11 w-11 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-339" data-mp="26k27krnl7mqx" />
                <span className="min-w-0" data-id="element-340" data-mp="1xj436898ld7t">
                  <span className="block text-[14px] font-bold text-ink" data-id="element-341" data-mp="r3a7vmnl17t4">{t.name}</span>
                  <span className="block text-[12.5px] text-ink-muted" data-id="element-342" data-mp="r17b8jrxcgff">{t.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA transformation="Join the dentists who stopped starting from zero." label="Join them for $27" subline="Instant access · 7-day guarantee" data-id="element-343" data-mp="njjimmz2pg5u" />
      </div>
    </section>;
}